import { Snackbar, Alert as MuiAlert } from '@mui/material';
import useAlert from './useAlert';

const Alert = () => {
    const {state, hide} = useAlert();

    return (
        <Snackbar
            autoHideDuration={2000}
            open={state.open}
            onClose={(event, reason) => reason !== 'clickaway' && hide()}
        >
            <MuiAlert
                severity={state.type}
                elevation={6}
                variant="filled"
                sx={{width: '100%'}}
                onClose={hide}
            >
                {state.text}
            </MuiAlert>
        </Snackbar>
    );
};

export default Alert;
